import {
  BlueBirdTheme,
  Loading,
  Scrollbar,
  Typography,
} from "@kitbird/core";
import Table from "../../../../../components/Table";
import { ColumnI } from "../../../../../components/Table/TableProps";
import {
  LoadingContainer,
} from "./MutationUser.styled";

interface TableCurrentPositionsProps {
  dataSource: {
    department: string;
    pool: string;
    status: string;
    jobTitle?: string;
  }[];
  hasPrimaryColor?: boolean;
  isLoading: boolean;
  hideTitle?: boolean;
}

const TableCurrentPositions = ({
  dataSource,
  hasPrimaryColor,
  isLoading,
  hideTitle = false,
}: TableCurrentPositionsProps) => {
  const showJobTitle = dataSource && dataSource.some((item) => !!item.jobTitle);
  const baseColumns: ColumnI[] = [
    {
      title: "Departemen",
      dataIndex: "department",
      key: "department",
    },
    {
      title: "Pool",
      dataIndex: "pool",
      key: "pool",
    },
  ];
  const jobTitleColumn: ColumnI = {
    title: "Jabatan",
    dataIndex: "jobTitle",
    key: "jobTitle",
  };

  const columns: ColumnI[] = showJobTitle
    ? [...baseColumns, jobTitleColumn]
    : baseColumns;

  if (isLoading) {
    return (
      <LoadingContainer>
        <Loading variant="circular" />
      </LoadingContainer>
    );
  }

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: ".2rem",
      marginTop: hasPrimaryColor ? "1rem" : 0,
    }}>
      {!hideTitle && (
        <Typography
          level={6}
          fontWeight="medium"
          color={hasPrimaryColor
            ? BlueBirdTheme.colors.primary[600]
            : BlueBirdTheme.colors.gray.subtitle
          }
        >
          Posisi saat ini
        </Typography>
      )}
      <Scrollbar maxHeight={"320px"}>
        <Table
          withNumber
          dataSource={dataSource}
          columns={columns}
          emptyMessage="Karyawan ini belum memiliki riwayat penempatan pool sebelumnya."
        />
      </Scrollbar>
    </div>
  );
};

export default TableCurrentPositions;
